import { queryOptions } from "@tanstack/react-query"
import axios from "axios"
import { AmphoraIntegrationResponseDataSchema, DataResponse } from "schema"
import { z } from "zod"

type Response = DataResponse<z.infer<typeof AmphoraIntegrationResponseDataSchema>>

const queryKey = ["amphoraIntegrationConfiguration"]

export const amphoraIntegrationQuery = () => {
  return queryOptions({
    queryKey,
    queryFn: async () => {
      const response = await axios.get<Response>(`/integrations/amphora`)

      return response.data.data
    },
  })
}
